(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    (function() {
  if (window.__bspCardInit) return;
  window.__bspCardInit = true;

  var cartQty = {};

  /* ═══════════════════════════════════════════
     Helper: check if Shopify error is sold-out
     ═══════════════════════════════════════════ */
  function isSoldOutError(msg) {
    if (!msg) return false;
    var lower = msg.toLowerCase();
    return lower.indexOf('sold out') > -1 ||
           lower.indexOf('not available') > -1 ||
           lower.indexOf('not enough') > -1 ||
           lower.indexOf('all items are out of stock') > -1 ||
           lower.indexOf('inventory') > -1;
  }

  function markSoldOut(btn) {
    btn.disabled = true;
    btn.classList.remove('is-stepper', 'is-loading');
    btn.classList.add('bsp-card__atc--disabled');
    btn.innerHTML = '<span class="bsp-card__atc-text" data-bsp-atc-text>Sold Out</span><span class="bsp-card__spinner"></span>';
  }

  /* ═══════════════════════════════════════════
     Safe fetch: parse Shopify error from response
     ═══════════════════════════════════════════ */
  function cartAdd(vid, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(vid), quantity: qty || 1 }] })
    }).then(function(r) {
      if (!r.ok) {
        return r.json().catch(function() { return {}; }).then(function(d) {
          var err = new Error(d.description || d.message || 'Failed to add');
          err.shopifyMsg = d.description || d.message || '';
          err.isSoldOut = isSoldOutError(err.shopifyMsg);
          throw err;
        });
      }
      return r.json();
    });
  }

  /* ═══════════════════════════════════════════
     Cart Drawer — cache-busted sections refresh
     ═══════════════════════════════════════════ */
  function refreshCartDrawer() {
    var cartForm = document.querySelector('form#cart.mini-cart');
    if (!cartForm) return Promise.resolve();
    var sectionEl = cartForm.closest('[id^="shopify-section-"]');
    if (!sectionEl) return Promise.resolve();
    var sectionId = sectionEl.id.replace('shopify-section-', '');

    return fetch('/?sections=' + sectionId + '&_=' + Date.now())
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var html = data[sectionId];
        if (!html) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newForm = doc.querySelector('form#cart.mini-cart');

        if (newForm) {
          cartForm.classList.toggle('is-empty', newForm.classList.contains('is-empty'));
        }
        var newMain = doc.getElementById('main-cart-items');
        var oldMain = document.getElementById('main-cart-items');
        if (newMain && oldMain) oldMain.innerHTML = newMain.innerHTML;

        var newSubs = doc.querySelectorAll('#mini-cart-subtotal');
        var oldSubs = document.querySelectorAll('#mini-cart-subtotal');
        newSubs.forEach(function(ns, i) { if (oldSubs[i]) oldSubs[i].innerHTML = ns.innerHTML; });

        var newFooter = doc.querySelector('.mini-cart__footer');
        var oldFooter = document.querySelector('.mini-cart__footer');
        if (newFooter && oldFooter) oldFooter.innerHTML = newFooter.innerHTML;

        var newShip = doc.querySelector('.free-shipping');
        var oldShip = document.querySelector('.free-shipping');
        if (newShip && oldShip) oldShip.outerHTML = newShip.outerHTML;
        else if (newShip && !oldShip) {
          var hdr = document.querySelector('.mini-cart__header');
          if (hdr) hdr.insertAdjacentHTML('beforeend', newShip.outerHTML);
        }

        var newEmpty = doc.querySelector('.mini-cart__empty');
        var oldEmpty = document.querySelector('.mini-cart__empty');
        if (newEmpty && oldEmpty) oldEmpty.innerHTML = newEmpty.innerHTML;
      })
      .catch(function() {});
  }

  /* ═══════════════════════════════════════════
     Open Cart Drawer
     ═══════════════════════════════════════════ */
  function openCartDrawer() {
    var cartForm = document.querySelector('form#cart.mini-cart');
    if (!cartForm) return;

    var details = cartForm.closest('details');
    if (details && !details.open) {
      var summary = details.querySelector(':scope > summary');
      if (summary) { summary.click(); return; }
      details.open = true;
      return;
    }

    var allDetails = document.querySelectorAll('details');
    for (var i = 0; i < allDetails.length; i++) {
      var d = allDetails[i];
      if (d.querySelector('#cart, form.mini-cart') && !d.open) {
        var s = d.querySelector(':scope > summary');
        if (s) { s.click(); return; }
        d.open = true;
        return;
      }
    }

    var icons = document.querySelectorAll(
      'a[href="/cart"], ' +
      '[class*="cart-icon"], ' +
      '[class*="header__icon--cart"], ' +
      'button[aria-controls*="cart"]'
    );
    for (var j = 0; j < icons.length; j++) {
      var icon = icons[j];
      if (!icon.closest('.mini-cart') && !icon.closest('form#cart') && !icon.closest('drawer-close-button')) {
        icon.click();
        return;
      }
    }
  }

  /* ── Hydrate steppers from current cart ── */
  function hydrateFromCart() {
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      cartQty = {};
      cart.items.forEach(function(item) {
        cartQty[item.variant_id] = (cartQty[item.variant_id] || 0) + item.quantity;
      });
      document.querySelectorAll('.bsp-card__atc[data-bsp-atc-btn]').forEach(function(btn) {
        var vid = btn.getAttribute('data-variant-id');
        if (cartQty[vid] && cartQty[vid] > 0) renderStepper(btn, vid, cartQty[vid]);
      });
    }).catch(function() {});
  }
  hydrateFromCart();

  function renderStepper(btn, vid, qty) {
    btn.classList.add('is-stepper');
    btn.classList.remove('is-loading', 'bsp-card__atc--disabled');
    btn.disabled = false;
    btn.innerHTML =
      '<span class="bsp-card__step-btn" data-bsp-step="minus" data-bsp-step-vid="' + vid + '">&minus;</span>' +
      '<span class="bsp-card__step-qty">' + qty + ' in Cart</span>' +
      '<span class="bsp-card__step-btn" data-bsp-step="plus" data-bsp-step-vid="' + vid + '">+</span>';
  }

  function resetButton(btn, isPreOrder) {
    btn.classList.remove('is-stepper', 'is-loading', 'bsp-card__atc--disabled');
    btn.disabled = false;
    btn.innerHTML = '<span class="bsp-card__atc-text" data-bsp-atc-text>' + (isPreOrder ? 'Pre Order' : 'Add To Cart') + '</span><span class="bsp-card__spinner"></span>';
  }

  function updateCartCount(cart) {
    document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .header__cart-count').forEach(function(el) {
      el.textContent = cart.item_count;
    });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
  }

  /* ── Variant Selector ── */
  document.addEventListener('change', function(e) {
    var select = e.target.closest('[data-bsp-variant-select]');
    if (!select) return;
    var card = select.closest('.bsp-card');
    if (!card) return;
    var opt = select.options[select.selectedIndex];
    var variantId = opt.value;
    var priceEl = card.querySelector('[data-bsp-price]');
    var mrpEl = card.querySelector('[data-bsp-mrp]');
    var offEl = card.querySelector('[data-bsp-off]');
    if (opt.dataset.onSale === 'true') {
      priceEl.textContent = opt.dataset.price;
      mrpEl.innerHTML = 'M.R.P.: <s>' + opt.dataset.comparePrice + '</s>';
      mrpEl.style.display = ''; offEl.textContent = opt.dataset.savePercent + '% OFF'; offEl.style.display = '';
    } else {
      priceEl.textContent = 'M.R.P.: ' + opt.dataset.price;
      mrpEl.style.display = 'none'; offEl.style.display = 'none';
    }
    var btn = card.querySelector('[data-bsp-atc-btn]');
    if (btn) {
      btn.setAttribute('data-variant-id', variantId);
      if (opt.dataset.available === 'true') {
        btn.classList.remove('bsp-card__atc--disabled');
        if (cartQty[variantId] && cartQty[variantId] > 0) renderStepper(btn, variantId, cartQty[variantId]);
        else resetButton(btn, false);
      } else {
        markSoldOut(btn);
      }
    }
  });

  /* ── Click Handler ── */
  document.addEventListener('click', function(e) {
    /* ── Stepper +/- ── */
    var stepBtn = e.target.closest('[data-bsp-step]');
    if (stepBtn) {
      e.preventDefault(); e.stopPropagation();
      if (stepBtn.classList.contains('is-busy')) return;
      var vid = stepBtn.dataset.bspStepVid;
      var action = stepBtn.dataset.bspStep;
      var currentQty = cartQty[vid] || 0;
      var newQty = action === 'plus' ? currentQty + 1 : currentQty - 1;
      var atcBtn = stepBtn.closest('.bsp-card__atc');
      var allStepBtns = atcBtn ? atcBtn.querySelectorAll('.bsp-card__step-btn') : [];
      allStepBtns.forEach(function(b) { b.classList.add('is-busy'); });

      if (action === 'plus') {
        cartAdd(vid, 1)
        .then(function() { cartQty[vid] = newQty; if (atcBtn) renderStepper(atcBtn, vid, newQty); return fetch('/cart.js'); })
        .then(function(r) { return r.json(); })
        .then(function(cart) { updateCartCount(cart); refreshCartDrawer(); })
        .catch(function(err) {
          allStepBtns.forEach(function(b) { b.classList.remove('is-busy'); });
          if (err && err.isSoldOut && atcBtn) {
            /* variant ran out of stock mid-session — lock the stepper plus */
            markSoldOut(atcBtn);
            cartQty[vid] = 0;
          }
        });
      } else {
        var updates = {}; updates[vid] = Math.max(newQty, 0);
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
        .then(function(r) { if (!r.ok) throw new Error('Failed'); return r.json(); })
        .then(function(cart) {
          if (newQty <= 0) { cartQty[vid] = 0; if (atcBtn) resetButton(atcBtn, false); }
          else { cartQty[vid] = newQty; if (atcBtn) renderStepper(atcBtn, vid, newQty); }
          updateCartCount(cart); refreshCartDrawer();
        })
        .catch(function() { allStepBtns.forEach(function(b) { b.classList.remove('is-busy'); }); });
      }
      return;
    }

    /* ── Initial Add To Cart ── */
    var btn = e.target.closest('.bsp-card__atc[data-variant-id]');
    if (!btn || btn.classList.contains('is-loading') || btn.classList.contains('is-stepper') || btn.disabled) return;
    var variantId = btn.getAttribute('data-variant-id');
    btn.classList.add('is-loading');

    cartAdd(variantId, 1)
    .then(function() {
      cartQty[variantId] = (cartQty[variantId] || 0) + 1;
      renderStepper(btn, variantId, cartQty[variantId]);
      return fetch('/cart.js');
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      updateCartCount(cart);
      refreshCartDrawer().then(function() {
        setTimeout(openCartDrawer, 100);
      });
    })
    .catch(function(err) {
      btn.classList.remove('is-loading');
      if (err && err.isSoldOut) {
        markSoldOut(btn);
      } else {
        var label = btn.querySelector('.bsp-card__atc-text');
        if (label) { label.textContent = 'Retry'; setTimeout(function() { label.textContent = 'Add To Cart'; }, 2000); }
      }
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
